import {GetDiscountsResponse_Discount} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/campaigns/v1/service.types';
import {useCallback} from 'react';
import {
  SelectedDiscountValue,
  useSelectedDiscountCallback,
} from '../SelectedDiscounts/useSelectedDiscount';

const getIsDiscountActive = (
  discount: GetDiscountsResponse_Discount,
  selectedDiscount: SelectedDiscountValue,
) => {
  return discount.id === selectedDiscount?.id;
};

export const useGetActiveDiscountCallback = () => {
  const getSelectedDiscount = useSelectedDiscountCallback();

  return useCallback(
    async (discounts: GetDiscountsResponse_Discount[] | undefined) => {
      if (!discounts) {
        return;
      }
      const selectedDiscount = await getSelectedDiscount();

      return discounts.find(discount =>
        getIsDiscountActive(discount, selectedDiscount),
      );
    },
    [getSelectedDiscount],
  );
};
